
<template>
     <div class="dashboard-container">
        <component :is="currentRole" v-on:handleLogin="handleLogin" ref="login"/>
    </div>
</template>

<script>
    import loginIndex from './Login/index'

    import { setToken } from '@/utils/auth'
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {removeToken} from '@/utils/auth';

    export default {
        name: 'Login',
        data() {
            return {
                currentRole: 'loginIndex'
            }
        },
        components:{
            loginIndex
        },
        created(){

          this.currentRole = 'loginIndex'

        },
        watch: {

        },
        methods: {
            handleLogin(loginForm) {
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'Staff/Login',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5( "timeStr=" + timeStr + "&key="+this.$signKey),
                        loginName: loginForm.username,
                        password: loginForm.password,
                    }
                }).then( (response)=> {
                    this.loading = false
                    if(response.data.error == 0){

                        removeToken();
                        window.localStorage.setItem('activeInstitutionCode', null);
                        window.localStorage.setItem('activeStaffCode', null);
                        window.localStorage.setItem('activeMenuTop', null);
                        window.localStorage.setItem('listMenuDTO', null);
                        window.localStorage.setItem('listMenuTop', null);
                        window.localStorage.setItem('listMenuLeft', null);
                        window.localStorage.setItem('isHome', null);

                        // if(response.data.data.businessDTO){
                        //     this.$set(response.data.data,'businessName',response.data.data.businessDTO.userDTO.name)
                        //     this.$set(response.data.data,'businessCode',response.data.data.businessDTO.businessCode)
                        // }
                        // if(response.data.data.governmentDTO){
                        //     this.$set(response.data.data,'governmentName',response.data.data.governmentDTO.name)
                        // }
                        // this.$delete(response.data.data, 'businessDTO');
                        // this.$delete(response.data.data, 'governmentDTO');


                        let str = JSON.stringify(response.data.data);
                        let staff = JSON.parse(str);
                        this.$store.commit('update', ['loginToken',staff]);
                        setToken(staff);

                        // if(staff.roleName=='政府管理员'){
                        //     this.$store.commit('update', ['activeMenuTop','/indexTop']);
                        //     window.localStorage.setItem('activeMenuTop', '/indexTop');
                        //     window.localStorage.setItem('isHome', true);
                        //     this.$router.push({ path:'/home/indexOne', query: { isHome: true }})
                        // }else{
                        //     window.localStorage.setItem('isHome', false);
                        //     this.getMenu(staff);
                        // }
                      //window.localStorage.setItem('isHome', false);

                      this.getMenu(staff);

                    }else if(response.data.error == 1){
                        this.$refs.login.loading=false
                        this.$refs.login.refreshCode()
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }


                }).catch(function (error) {
                    console.log(error);
                });
            },
          getMenu(staff){

            this.$axios({
              method: 'post',
              url: this.$shopUrl+'Staff/StaffMenu',
              data: {
                timeStr:timeStr,
                sign:hex_md5( "timeStr=" + timeStr + "&key="+this.$signKey),
                staffCode: staff.staffCode,
              }
            }).then( (response)=> {
              if(response.data.error == 0){
                var listMenuDTO=response.data.data
                if(listMenuDTO.length>0){
                  this.$store.commit('update', ['listMenuDTO',listMenuDTO]);
                  window.localStorage.setItem('listMenuDTO', JSON.stringify(listMenuDTO));
                  let listMenuDTO2 = [];
                  for(var i=0;i<listMenuDTO.length;i++){
                    var obj = {"name":listMenuDTO[i].name,"menuCode":listMenuDTO[i].menuCode,"url":listMenuDTO[i].url};
                    listMenuDTO2.push(obj);
                  }
                  this.$store.commit('update', ['listMenuTop',listMenuDTO2]);
                  window.localStorage.setItem('listMenuTop', JSON.stringify(listMenuDTO2));

                  let listMenuLeft = listMenuDTO[0].listMenuDTO;
                  this.$store.commit('update', ['activeMenuTop',listMenuDTO[0].url]);
                  window.localStorage.setItem('activeMenuTop',listMenuDTO[0].url);
                  if(listMenuLeft[0].listMenuDTO.length==0){
                    //this.$router.push(listMenuLeft[0].url)
                  }else{
                    //this.$router.push(listMenuLeft[0].listMenuDTO[0].url)
                  }
                  this.$store.commit('update', ['listMenuLeft',listMenuLeft]);
                  window.localStorage.setItem('listMenuLeft', JSON.stringify(listMenuLeft));
                }
                this.$router.push({ path:'/home/index' })

              }else if(response.data.error == 1){
                this.$message(response.data.message);
              }else{
                console.log(response.data.message);
              }
            }).catch(function (error) {
              console.log(error);
            });

          },

        }
    }

</script>

<style lang="scss" scoped>
    .dashboard-container{
        height: 100vh;
    }
</style>
